import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=3b722b3d&scoped=true&"
import script from "./Captcha.vue?vue&type=script&lang=ts&"
export * from "./Captcha.vue?vue&type=script&lang=ts&"
import style0 from "./Captcha.vue?vue&type=style&index=0&id=3b722b3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b722b3d",
  null
  
)

export default component.exports